import { render, staticRenderFns } from "./VerTestigos.vue?vue&type=template&id=13e3eb50&scoped=true"
import script from "./VerTestigos.vue?vue&type=script&lang=js"
export * from "./VerTestigos.vue?vue&type=script&lang=js"
import style0 from "./VerTestigos.vue?vue&type=style&index=0&id=13e3eb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e3eb50",
  null
  
)

export default component.exports